module.exports = __webpack_public_path__ + "static/media/gcdef_102.8f5cc4de.ico";